/*
 *  Custom Theme Javascript Code.
 *
 */
jQuery(document).ready(function($){

	"use strict";
	
	dismissibleHeader();
	submenuToggle();
	offCanvasToggle();
	
	$('[data-toggle="tooltip"]').tooltip();
	
	/*
	 *  Add/Remove the "stuck" class to the site header
	 *  based on current position.
	 *
	 */
	var currentPosition = $(window).scrollTop();
	if(currentPosition > 80) { $('.site-header').addClass('stuck'); }
	$(window).on('scroll', function(e){
		
		currentPosition = $(window).scrollTop();
		if(currentPosition > 80) {
			$('.site-header').addClass('stuck');
		} else {
			$('.site-header').removeClass('stuck');
		}
		
	});
	
	/*
	 *  Initiate Cycle2 Slider.
	 *  This is used for when a banner section is set to "Slide" mode.
	 *
	 *  @link  http://jquery.malsup.com/cycle2/
	 *
	 */
	$('.slides').cycle();
	
	/*
	 *  Expand/Collapse sidebar menus on mobile.
	 *
	 */
	$('.sidebar-expand').on('click', function(e){
		
		e.preventDefault();
		
		var filter_menu = $(this).next().next();
		var icon        = $(this).find('i');
		
		filter_menu.toggleClass('expanded').slideToggle(500);
		if( icon.hasClass('fa-plus') ) {
			icon.addClass('fa-minus').removeClass('fa-plus');
		} else {
			icon.addClass('fa-plus').removeClass('fa-minus');
		}
		
	});
	
	/*
	 * Toggle the visibility of account forms.
	 *
	 */
	$('.address-edit-toggle').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().next().removeClass('hidden');
		
	});
	
	$('.address-edit-cancel').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().parent().addClass('hidden');
		
	});
	
	$('.recover-password-toggle').on('click', function(e){
		
		e.preventDefault();
		$(this).parent().next().toggleClass('hidden');
		
	});
	
	/*
	 *  Expand/collapse rich text sections.
	 *
	 */
	$('.rich-accordion-header').on('click', function(e){
		
		e.preventDefault();
		
		$(this).parent().parent().next().toggleClass('expanded');
		$(this).find('.fa').toggleClass('fa-minus').toggleClass('fa-plus');
		
	});
	
	/*
	 *  Update the main product featured image when thumbnails are clicked.
	 *  Also uses Zoom plugin for product zoom.
	 *
	 *  @link  http://www.jacklmoore.com/zoom
	 *
	 */
	$('.product-images img').on('click', function(){
		
		var new_url    = $(this).attr('data-featured');
		var master_url = $(this).attr('data-master');
		
		$('.product-featured-image').replaceWith('<img class="product-featured-image" src="' + new_url + '" alt="" data-zoom="' + master_url + '">');
		$('.product-featured-image-wrapper').trigger('zoom.destroy');
		if(jQuery.zoom) {
			
			$('.product-featured-image-wrapper').zoom({
				
				url:   master_url,
				touch: false
				
			});
			
		}
		
	});
	if(jQuery.zoom) {
	
		$('.product-featured-image-wrapper').zoom({
		
			url:   $('.product-featured-image-wrapper').find('img').attr('data-zoom'),
			touch: false
	
		});
	
	}
	
	/*
	 *  Add "Load More" functionality via ajax.
	 *
	 */
	var triggered = false;
	
	$('.load-more').off('click').on('click', function(e){
		
		e.preventDefault();
		
		var target = $('.load-more').attr('href');
		if(triggered == false) {
			
			triggered = true;
			$.ajax({
				
				url:     target,
				type:    'GET',
				success: function(data){
				
					var newTarget = $(data).find('.load-more').attr('href');
					if( is_collection_page || is_search_page ) {
						var filteredData = $(data).find('.product-column');
					} else {
						var filteredData = $(data).find('.blog-column');
					}
				
					if( is_collection_page || is_search_page ) {
						$('.product-loop').append(filteredData);
					} else {
						$('.blog-loop').append(filteredData);
					}
					
					$('.load-more').attr('href', newTarget);
					if( ! newTarget ) {
						$('.load-more').remove();
					}
				
					triggered = false;
					addToCart();
				
				}
				
			});
			
		}
		
	});
	
	/*
	 *  Add products to the cart object via ajax.
	 *  Used on collection pages.
	 *
	 *  @link  https://help.shopify.com/en/themes/development/getting-started/using-ajax-api
	 *
	 */
	function addToCart(){
		
		$('.add-to-cart').off('click').on('click', function(e){
			
			e.preventDefault();
			
			var form   = $(this).parent();
			var result = $(this).parent().next();
			
			$.ajax({
				
				type:     'POST', 
				url:      '/cart/add.js',
				dataType: 'json', 
				data:     form.serialize(),
				success:  function(product){
					
					cartCount ++;
					cartTotal += product.price;
					
					console.log(product);
					
					/*
					 *  If this is the first item in the cart, we need to add a wrapper.
					 *
					 */
					if( cartCount == 1 ){
						var wrapperStart = '<div class="header-cart-contents"><div class="header-cart-loop">';
						var wrapperEnd   = '</div>' +
							
							'<form class="header-cart-contents-cta d-flex" action="/cart" method="post" novalidate>' +
								'<a href="/cart" class="btn btn-primary header-cart-contents-view-cart">' + theme.strings.addToCart + '</a>' +
								'<button class="btn btn-secondary header-cart-contents-checkout" type="submit" name="checkout">' + theme.strings.checkout + '</button>' +
							'</form>' +
							'</div>';
							
					} else {
						var wrapperStart = '';
						var wrapperEnd   = '';
					}
					
					var cartHTML = '' +
					
						'<div class="shop-icon-basket-inner">' +
							'<i class="' + cartIcon + '"></i>' +
							'<span class="cart-item-count">' + cartCount + '</span>' +
						'</div>';
					
					$('.shop-icon-basket-inner').replaceWith(cartHTML);
					
					if( has_icon_text ) {
						
						var icon_text = '<span class="icon-label icon-label-cart"><span class="money">' + Shopify.formatMoney(cartTotal) + '</span></span>';
						$('.icon-label-cart').replaceWith(icon_text);
					
					}
					
					var mobileCartHTML = '' +
					
						'<div class="mobile-cart-wrapper">' +
							'<a href="/cart" class="mobile-cart"><i class="' + cartIcon + '"></i></a>' +
							'<span class="cart-item-count">' + cartCount + '</span>' +
						'</div>';
					
					$('.mobile-cart-wrapper').replaceWith(mobileCartHTML);
					
					var pos = product.image.lastIndexOf('.');
					var product_image_small = product.image.substring(0,pos) + '_120x120_crop_center.' + product.image.substring(pos+1);
					var trimmed_title = product.title.substring(0,20);
					var itemHTML = '' +
					
						wrapperStart +
						'<div class="header-cart-contents-item d-flex">' +
							'<div class="header-cart-contents-product-image">' +
								'<a href="' + product.url + '">' +
									'<img src="' + product_image_small + '" alt="' + product.title + '">' +
								'</a>' +
							'</div>' +
							'<div class="header-cart-contents-product-details d-flex flex-column justify-content-center text-left">' +
								'<span class="header-cart-contents-product-quantity">' + theme.strings.qty + ' 1</span>' +
									'<h6 class="header-cart-contents-product-title">' +
										'<strong><a href="' + product.url + '">' + trimmed_title + '&hellip;</a></strong>' +
									'</h6>' +
								'<span class="header-cart-contents-product-price"><span class="money">' + Shopify.formatMoney(product.price) + '</span></span>' +
							'</div>' +
						'</div>' +
						wrapperEnd;
					
					if(cartCount == 1) {
						$(itemHTML).appendTo('.store-icon-cart');
					} else {
						$(itemHTML).prependTo('.header-cart-loop');
					}
					
					result.addClass('in');
					setTimeout(function(){
						
						result.removeClass('in').addClass('out');
						
					}, 3000);
					
				},
				error: function(){
					
					result.html('<p>' + theme.strings.somethingWrong + '</p>');
					
				}
			
			});
			
		});
		
	}
	addToCart();
	
	/*
	 *  Add sorting functionality to collection pages.
	 *
	 */
	if( is_collection_page ) {
		
		/*
		 *  Sort products by default Shopify sort order
		 *
		 */
		Shopify.queryParams = {};				
		if(location.search.length) {
		
			for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
			
				aKeyValue = aCouples[i].split('=');
				
				if(aKeyValue.length > 1) {
				
					Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
				
				}
			
			}
		
		}
	
		$('#sort-by')
			.val(current_sort_by)
			.bind('change', function() {
			
				Shopify.queryParams.sort_by = jQuery(this).val();
				location.search             = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
			
		});
		
		/*
		 *  Change the number of products to view per page.
		 *
		 */
		$('#num-products').on('change', function(e){
		
			var url = $(this).val();
			window.location.href = url;
		
		});
		
	}

});

/*
 *  Dynamic search bar functionality.
 *
 *  Adds the ability for users to view porducts as they're typing search terms.
 *
 */
$(function() {
	
	var currentAjaxRequest = null;
	var searchForms        = $('form[action="/search"]').each(function() {
	
		var input = $(this).find('input[name="q"]');
		input.attr('autocomplete', 'off').bind('keyup change', function() {
			
			var term = $(this).val();
			var form = $(this).closest('form');
			
			var searchURL   = '/search?type=product&q=*' + term + '*';
			var resultsList = $('.ajax-search-results');
			
			if (term.length > 3 && term !== $(this).attr('data-old-term')) {
				
				$(this).attr('data-old-term', term);
				if (currentAjaxRequest !== null) currentAjaxRequest.abort();
				
				currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
					
					resultsList.empty();
					
					if (data.results_count === 0) {
						
						resultsList.html('<p class="ajax-no-results">' + theme.strings.nothingFound + '</p>');
						resultsList.fadeIn(200);
					
					} else {
					
						$.each(data.results, function(index, item) {
						
							var ajax_search_html = '' +
							
								'<a href="' + item.url + '" class="ajax-search-item d-flex justify-content-start align-items-center">' +
									'<img class="ajax-search-item-thumbnail" src="' + item.thumbnail + '" src="' + item.title + '">' +
									'<div class="ajax-search-content">' +
										'<h6 class="ajax-search-item-title">' + item.title + '</h6>' +
										'<span class="ajax-search-item-price">' + item.price + '</span>' +
									'</div>' +
								'</a>';
						
							resultsList.append(ajax_search_html);
							
						});
						
						resultsList.append('<a class="ajax-search-more" href="' + searchURL + '">' + theme.strings.view + ' ' + data.results_count + ' ' + theme.strings.moreItems + '</a>');
						resultsList.fadeIn(200);
						
					}
					
				});
	
			}
		
		});
	
	});
	
	$('body').bind('click', function(){
		
		$('.ajax-search-results').hide();
	
	});

});

/*
 *  Toggle visibility of the off-canvas menu.
 *
 */
function offCanvasToggle(){
	
	$('.mobile-menu').on('click', function(e){
		e.preventDefault();
		$('.off-canvas').addClass('in');
	});
	
	$('.off-canvas-close').on('click', function(e){
		e.preventDefault();
		$('.off-canvas').removeClass('in');
	});
	
}

/*
 *  Toggle submenu visibility on mobile navigation.
 *
 */
function submenuToggle(){
	
	$('.mobile-submenu-toggle').on('click', function(e){
		
		e.preventDefault();
		var icon = $(this).find('i');
		
		$(this).next().slideToggle(200);
		
		if( icon.hasClass('fa-plus') ) {
			icon.removeClass('fa-plus').addClass('fa-minus');
		} else {
			icon.removeClass('fa-minus').addClass('fa-plus');
		}
		
	});

}

/*
 *  The "Close" button to dismiss the top site header.
 *
 */
function dismissibleHeader(){
	
	$('.site-header-top-close').on('click', function(e){
		
		e.preventDefault();
		
		$('.site-header-top').addClass('closed');
		$('body').addClass('header-is-closed');
		
	}); 
	
}

/*
 *  Any scripts that need to be re-invoked should use the shopify:section:load event.
 *
 */
jQuery(document).on( 'shopify:section:load', function(){
	
	dismissibleHeader();
	submenuToggle();
	offCanvasToggle();
	jQuery('.slides').cycle();
	
});